<template>
    <div class="profile">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="xl" ref="model_list" title="Lista modelos">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Lista Modelos</h3>
                <div v-for="(model, index) in modelos" :key="index">
                    <label for="">{{"- " + model.name }} <span>Monitor {{"-" + model.monitor }}</span></label>
                </div>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="monitor_list" title="Lista monitores">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Lista Monitores</h3>
                <div v-for="(model, index) in monitores" :key="index">
                    <label for="">{{"- " + model }}</label>
                </div>
            </div>
        </b-modal>
        <div class="column">
            <div class="left-zone">
                <div class="platforms">
                    <center>
                        <br>
                        <br>
                        <button v-if="this.user_type === 'Administrador' || this.user_type === 'Monitor'" @click="$refs.model_list.show()">Lista Modelos</button>
                        <button v-if="this.user_type === 'Administrador'" @click="$refs.monitor_list.show()">Lista Monitoras</button>
                        <h3 v-if="this.user_type !== 'Administrador' && this.user_type !== 'Monitor'">PARA ADMINISTRADORAS Y MONITORAS</h3>
                    </center>
                </div>
            </div>
            <div class="right-zone">
                <div class="important-zone">
                    <center>
                        <div class="img-zone">
                            <input type="file" ref="select_file_profile" name="photo" @change="profileUpdatePhoto" class="register-file" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp" />
                            <img @click="$refs.select_file_profile.click()" :src="profile_picture" alt="" >
                        </div>
                        <div>
                            <label for="">Estado:</label>
                            <div>
                                <div :style="{'background-color': status_color}"></div>
                                <b-form-select v-model="status_name" class="select" @change="changeStatus">
                                    <option value="no_assoc">En creación</option>
                                    <option value="pending">Pendiente</option>
                                    <option value="approved">Activa</option>
                                    <option value="block">Bloqueada</option>
                                </b-form-select>
                            </div>
                        </div>
                        <button>Dar de baja</button>
                    </center>
                </div>
            </div>
        </div>
        <div class="column">
            <div class="left">
                <div class="info">
                    <center>
                        <h3>Información</h3>
                        <div class="info-box">
                            <div>
                                <label for="">Nombre</label>
                                <input type="text" v-model="name">
                            </div>
                            <div>
                                <label for="">Apellido</label>
                                <input type="text" v-model="lastname">
                            </div>
                            <div>
                                <label for="">Tipo de documento</label>
                                <b-form-select v-model="documentType">
                                    <option value="cc">Cedula de ciudadania</option>
                                    <option value="ce">Cedula de extranjeria</option>
                                    <option value="pasaport">Pasaporte</option>
                                    <option value="other">Otro</option>
                                </b-form-select>
                            </div>
                            <div>
                                <label for="">N° Documento</label>
                                <input type="number" v-model="document">
                            </div>
                            <div>
                                <label for="">Email</label>
                                <input type="email" v-model="email">
                            </div>
                            <div>
                                <label for="">Nacionalidad</label>
                                <b-form-select v-model="location_of_birth">
                                    <option v-for="(elem, index) in countries" :key="index" :value="elem">{{ elem }}</option>
                                </b-form-select>
                            </div>
                            <div>
                                <label for="">Fecha de nacimiento</label>
                                <input type="date" v-model="date_of_birth">
                            </div>
                            <div>
                                <label for="">Celular</label>
                                <input type="tel" v-model="phone">
                            </div>
                            <div>
                                <label for="">Pais de Recidencia</label>
                                <b-form-select v-model="country">
                                    <option v-for="(elem, index) in countries" :key="index" :value="elem">{{ elem }}</option>
                                </b-form-select>
                            </div>
                            <div>
                                <label for="">Ciudad o Municipio</label>
                                <input type="text" v-model="location">
                            </div>
                            <div>
                                <label for="">Sexo</label>
                                <toggle-button
                                    v-model="sex"
                                    class="toggle"
                                    color="#82C7EB"
                                    :sync="true"
                                    :width="250"
                                    :height="40"
                                    :labels="{checked: 'MUJER', unchecked: 'HOMBRE'}"/>
                            </div>
                            <div>
                                <label for="">Turno</label>
                                <b-form-select name="" id="" v-model="turno">
                                    <option value="mañana">Mañana</option>
                                    <option value="tarde">Tarde</option>
                                    <option value="noche">Noche</option>
                                </b-form-select>
                            </div>
                            <div>
                                <label for="">Sede</label>
                                <b-form-select name="" id="" v-model="sede">
                                    <option :value="sede" v-for="(sede, index) in sedes" :key="index">{{sede}}</option>
                                </b-form-select>
                            </div>
                            <div>
                                <label for="">Tipo</label>
                                <b-form-select name="" id="" v-model="user_type">
                                    <option :value="type.name" v-for="(type, index) in users_types" :key="index">{{type.name}}</option>
                                </b-form-select>
                            </div>
                        </div>
                        <div class="button-box">
                            <button @click="updateProfileInfo()">Actualizar Informacion</button>
                        </div>
                    </center>
                </div>
            </div>
            <div class="right">
                <div class="bank">
                    <center>
                        <h3>Datos Bancarios</h3>
                        <div class="bank-box">
                            <div>
                                <label for="">Nombre</label>
                                <input type="text" v-model="nameUserBank">
                            </div>
                            <div>
                            <label for="">Tipo de documento</label>
                                <b-form-select v-model="documentTypeBank">
                                    <option value="cc">Cedula de ciudadania</option>
                                    <option value="ce">Cedula de extrangeria</option>
                                    <option value="pasaport">Pasaporte</option>
                                    <option value="other">Otroi</option>
                                </b-form-select>
                            </div>
                            <div>
                                <label for="">N° Documento</label>
                                <input type="text" v-model="BankDocument">
                            </div>
                            <div>
                                <label for="">Banco</label>
                                <input type="text" v-model="BankName">
                            </div>
                            <div>
                                <label for="">Tipo de cuenta</label>
                                <b-form-select v-model="bankTypeValue">
                                    <option value="ahorros">Ahorros</option>
                                    <option value="corriente">Corriente</option>
                                </b-form-select>
                            </div>
                            <div>
                                <label for="">N° Cuenta</label>
                                <input type="text" v-model="AccountNumber">
                            </div>
                        </div>
                        <div class="button-box">
                            <button @click="updateBankInfo()">Actualizar Informacion</button>
                        </div>
                    </center>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Notify from '@/utils/Notification.js'
import API from '@/api'
import RockerSwitch from 'vue-rocker-switch'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
    name: 'profile',
    components: {
        RockerSwitch,
        ToggleButton
    },
    data () {
        return {
            countries: [],
            name: null,
            address: null,
            date_of_birth: null,
            location_of_birth: null,
            country: 'Colombia',
            email: null,
            lastname: null,
            location: null,
            model_type: null,
            phone: null,
            sex: null,
            suspended_flag: null,
            suspended_reason: null,
            turno: null,
            profile_picture: null,
            documentType: null,
            document: null,
            nameUserBank: null,
            documentTypeBank: null,
            BankDocument: null,
            BankName: null,
            bankTypeValue: null,
            AccountNumber: null,
            status_name: null,
            status_color: null,
            sedes: [],
            sede: null,
            profilePicture: null,
            profilePictureObject: null,
            users_types: [],
            user_type: null,
            modelos: [],
            monitores: []
        }
    },
    methods: {
        profileUpdatePhoto (picture) {
            var file = picture.target.files || picture.dataTransfer.files
            if (!file.length) {
                return
            }

            this.saveImage(file[0], () => {
                API.updateProfilePicture(this.profilePictureObject, this.$route.params.admin_id)
                    .then(result => {
                        this.getProfileInfo()
                        Notify('dirty', 'Se ha cambiado la imagen del usuario')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
        },
        saveImage (file, cb) {
            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
                if (file.type === 'image/gif') {
                    vm.profilePicture = e.target.result
                    vm.profilePictureObject = file
                    if (cb) {
                        var toSend = {}
                        toSend.src = vm.profilePicture
                        cb(toSend)
                    }
                } else {
                    var image = new Image()
                    image.src = e.target.result
                    var width = 0
                    var height = 0
                    image.onload = function() {
                        width = this.width
                        height = this.height
                        var canvas = document.createElement('canvas')
                        var ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0)
                        var maxWidth = 400
                        var maxHeight = 400
                        if (width > height) {
                            if (width > maxWidth) {
                                height *= maxWidth / width
                                width = maxWidth
                            }
                        } else {
                            if (height > maxHeight) {
                                width *= maxHeight / height
                                height = maxHeight
                            }
                        }
                        canvas.width = width
                        canvas.height = height
                        ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0, width, height)
                        vm.profilePicture = canvas.toDataURL(file.type)
                        var byteString
                        if (vm.profilePicture.split(',')[0].indexOf('base64') >= 0) {
                            byteString = atob(vm.profilePicture.split(',')[1])
                        } else {
                            byteString = unescape(vm.profilePicture.split(',')[1])
                        }
                        var mimeString = vm.profilePicture.split(',')[0].split(':')[1].split(';')[0]
                        var ia = new Uint8Array(byteString.length)
                        for (var i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i)
                        }
                        try {
                            vm.profilePictureObject = new File([new Blob([ia], {type: mimeString})], file.type)
                        } catch (err) {
                            vm.profilePictureObject = new Blob([ia], {type: mimeString})
                            vm.profilePictureObject.name = file.name
                            vm.profilePictureObject.lastModifiedDate = new Date()
                        }

                        if (cb) {
                            cb(image)
                        }
                    }
                }
            }
            reader.readAsDataURL(file)
        },
        getSedesList() {
            API.getSedesList()
                .then((res) => {
                    this.sedes = res
                })
        },
        changeStatus() {
            if (this.status_name === 'no_assoc') {
                this.status_color = '#5bc0de'
            }
            if (this.status_name === 'pending') {
                this.status_color = '#f0ad4e'
            }
            if (this.status_name === 'approved') {
                this.status_color = '#22bb33'
            }
            if (this.status_name === 'block') {
                this.status_color = '#bb2124'
            }
            API.changeStatus(this.status_name, this.$route.params.admin_id)
                .then((res) => {
                    Notify('dirty', 'El estado de la modelo ' + this.name + '  se actualizo con exito')
                })
        },
        updateBankInfo() {
            var info = {
                uid: this.$route.params.admin_id,
                account_number: this.AccountNumber,
                bank_name: this.BankName,
                document: this.BankDocument,
                document_type: this.documentTypeBank,
                name: this.nameUserBank,
                type_account: this.bankTypeValue
            }
            API.updateBankInfo(info)
                .then((res) => {
                    this.getBankInfo()
                    Notify('dirty', 'La información bancaria de la modelo ' + this.name + '  se actualizo con exito')
                })
        },
        getModelsListByAdmin() {
            if (this.user_type !== 'Administrador' && this.user_type !== 'Monitor') {
                return
            }
            API.getModelsListByAdmin(this.$route.params.admin_id)
                .then((res) => {
                    this.modelos = res
                    this.modelos.forEach(model => {
                        if (!this.monitores.includes(model.monitor)) {
                            this.monitores.push(model.monitor)
                        }
                    })
                })
        },
        updateProfileInfo() {
            var info = {
                id: this.$route.params.admin_id,
                name: this.name,
                document: this.document,
                document_type: this.documentType,
                location_of_birth: this.location_of_birth,
                country: this.country,
                date_of_birth: this.date_of_birth,
                email: this.email,
                full_name: this.name + ' ' + this.lastname,
                location: this.location,
                model_type: this.model_type,
                phone: this.phone,
                sex: this.sex,
                turno: this.turno,
                sede: this.sede
            }
            API.updateAdminProfileInfo(info)
                .then((res) => {
                    this.getProfileInfo()
                    this.getPlatforms()
                    Notify('dirty', 'La información de perfil de la modelo ' + this.name + '  se actualizo con exito')
                })
        },
        showModalPlatform() {
            this.$refs.new_platforms.show()
        },
        getCountriesList: function() {
            this.$http.get('https://restcountries.com/v3.1/all').then(function(response) {
                var contries = []
                response.body.forEach(country => {
                    if (country.name.common === 'Tanzania') {
                        return
                    }
                    contries.push(country.name.common)
                })
                this.countries = contries.sort()
            })
        },
        getUsersTypes() {
            API.getUsersTypes()
                .then((res) => {
                    this.users_types = res
                })
        },
        getProfileInfo() {
            API.getAdminProfileInfo(this.$route.params.admin_id)
                .then((res) => {
                    if (res.status === 'no_assoc') {
                        this.status_color = '#5bc0de'
                    }
                    if (res.status === 'pending') {
                        this.status_color = '#f0ad4e'
                    }
                    if (res.status === 'approved') {
                        this.status_color = '#22bb33'
                    }
                    if (res.status === 'block') {
                        this.status_color = '#bb2124'
                    }
                    this.status_name = res.status
                    this.name = res.name
                    this.address = res.info.address
                    this.date_of_birth = res.info.date_of_birth.split(this.$store.state.constants.SEPARETOR)[0]
                    this.country = res.info.country
                    this.email = res.info.email
                    this.lastname = res.info.full_name.replace(res.name + ' ', '')
                    this.location = res.info.location
                    this.model_type = res.info.model_type === 1
                    this.phone = res.info.phone
                    this.sex = res.info.sex === 'F'
                    this.suspended_flag = res.info.suspended_flag
                    this.suspended_reason = res.info.suspended_reason
                    this.turno = res.info.turno
                    this.location_of_birth = res.info.location_of_birth
                    this.documentType = res.document_info.document_type
                    this.document = res.document_info.document
                    this.profile_picture = res.profile_picture
                    this.sede = res.sede
                    this.user_type = res.info.user_type
                    this.getModelsListByAdmin()
                })
        },
        getBankInfo() {
            API.getBankInfo(this.$route.params.admin_id)
                .then((res) => {
                    this.nameUserBank = res.name
                    this.documentTypeBank = res.document_type
                    this.BankDocument = res.document
                    this.BankName = res.bank_name
                    this.bankTypeValue = res.type_account
                    this.AccountNumber = res.account_number
                })
        }
    },
    beforeMount() {
        this.$root.$emit('changeModel', this.$route.name)
    },
    mounted() {
        this.getCountriesList()
        this.getBankInfo()
        this.getProfileInfo()
        this.getSedesList()
        this.getUsersTypes()
    }
}
</script>

<style scoped>
    .profile {
        background-color: #cdcdcd;
        min-height: 78vh;
        padding: 10px;
    }
    .profile > .column {
        height: 30%;
    }
    .profile > .column >  .left-zone {
        width: 70%;
        padding-right: 20px;
        height: 100%;
    }
    .profile > .column >  .right-zone {
        width: 30%;
        padding-left: 20px;
    }
    .profile > .column >  .left-zone > .platforms {
        width: 100%;
        height: 100%;
        padding: 20px;
        background-color: #63b763;
        border-radius: 20px;
        border-style: outset;
    }
    .profile > .column > .left-zone > .platforms > center > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .profile > .column > .right-zone > .important-zone {
        width: 100%;
        height: 100%;
        padding: 20px;
        background-color: #8363b7;
        border-radius: 20px;
        position: relative;
        border-style: outset;
    }
    .profile > .column > .right-zone > .important-zone > center > .img-zone {
        position: relative;
        width: 100px;
        height: 100px;
    }
    .profile > .column > .right-zone > .important-zone > center > .img-zone > input{
        display: none;
    }
    .profile > .column > .right-zone > .important-zone > center > .img-zone > img {
        width: 100px;
        height: 100px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        border-style: groove;
        object-fit: cover;
    }
    .profile > .column > .right-zone > .important-zone > center {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: auto;
        transform: translate(-50%, -50%);
    }
    .profile > .column > .right-zone > .important-zone > center > button {
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .profile > .column > .right-zone > .important-zone > center > div {
        display: inline-flex;
        width: 100%;
    }
    .profile > .column > .right-zone > .important-zone > center > div > label{
        font-size: 22px;
        color: #fff;
        padding-right: 20px;
    }
    .profile > .column > .right-zone > .important-zone > center > div > div{
        display: inline-flex;
        width: 100%;
    }
    .profile > .column > .right-zone > .important-zone > center > div > div > div{
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }
    .profile > .column > .right-zone > .important-zone > center > div > div > .select{
        font-size: 12px;
        width: 120px;
        height: 30px;
    }
    .profile > .column {
        display: flex;
        padding-top: 20px;
        height: 22vh;
    }
    .profile > .column > .left {
        width: 50%;
        padding-right: 20px;
    }
    .profile > .column > .right {
        width: 50%;
        padding-left: 20px;
    }
    .profile > .column > div > .info {
        width: 100%;
        background-color: #63b1b7;
        height: 50vh;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
    }
    .profile > .column > div > .info > center > .info-box{
        max-height: 35vh;
        overflow-y: auto;
    }
    .profile > .column > div > .bank > center > .bank-box{
        max-height: 35vh;
        overflow-y: auto;
    }
    .profile > .column > div > .info > center > .button-box{
       padding: 10px;
    }
    .profile > .column > div > .bank > center > .button-box{
       padding: 10px;
    }
    .profile > .column > div > .info > center > .button-box > button{
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .profile > .column > div > .bank > center > .button-box > button{
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .profile > .column > div > .info > center > .info-box > div > label{
        text-align: right;
    }
    .profile > .column > div > .info > center > .info-box > div {
        position: relative;
        text-align: left;
        margin: 15px;
    }
    .profile > .column > div > .info > center > .info-box > div > label{
        font-size: 22px;
        color: #fff;
    }
    .profile > .column > div > .info > center > .info-box > div > input, select{
        position: absolute;
        text-align: center;
        border-style: ridge;
        width: 250px;
        height: 40px;
        border-radius: 10px;
        margin-left: 20px;
        right: 0;
    }
    .profile > .column > div > .info > center > .info-box > div > .switch{
        position: absolute;
        text-align: center;
        width: 250px;
        height: 40px;
        margin-top: -10px;
        margin-left: 20px;
        right: 0;
    }
    .profile > .column > div > .info > center > .info-box > div > .toggle{
        position: absolute;
        margin-left: 20px;
        width: 250px;
        right: 0;
    }
    .profile > .column > div > .bank > center > .bank-box > div > label{
        text-align: right;
    }
    .profile > .column > div > .bank > center > .bank-box > div {
        position: relative;
        text-align: left;
        margin: 15px;
    }
    .profile > .column > div > .bank > center > .bank-box > div > label{
        font-size: 22px;
        color: #fff;
    }
    .profile > .column > div > .bank > center > .bank-box > div > input, select{
        position: absolute;
        text-align: center;
        border-style: ridge;
        width: 250px;
        height: 40px;
        border-radius: 10px;
        margin-left: 20px;
        right: 0;
    }
    .profile > .column > div > .bank > center > .bank-box > div > .switch{
        position: absolute;
        text-align: center;
        width: 250px;
        height: 40px;
        margin-top: -10px;
        margin-left: 20px;
        right: 0;
    }
    .profile > .column > div > .bank > center > .bank-box > div > .toggle{
        position: absolute;
        margin-left: 20px;
        width: 250px;
        right: 0;
    }
    .profile > .column > div > .bank {
        width: 100%;
        height: 50vh;
        background-color: #b78863;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
    }
    h3 {
        color: aliceblue;
    }
    .platforms-box {
        width: 100%;
        margin-top: 20px;
    }
    .platforms-box > .platform-item {
        display: inline-flex;
        margin: 15px;
    }
    .platforms-box > .platform-item > img{
        width: 100px;
    }
    .info-wrapper > img {
        width: 300px;
        margin-bottom: 50px;
    }
    .info-wrapper > div {
    }
    .info-wrapper > div > label {
        font-size: 22px;
        font-weight: bold;
    }
    .info-wrapper > div > input {
        text-align: center;
        border-style: ridge;
        width: 250px;
        height: 40px;
        border-radius: 10px;
        margin-left: 20px;

    }
    .info-wrapper > div > button {
        margin: auto;
        margin-top: 35px;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    .info-wrapper > button {
        margin: auto;
        margin-top: 35px;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    .info-wrapper > .toggle {
        position: absolute;
        right: 20px;
        top: 50px;
    }
    .info-wrapper > .cut {
        position: absolute;
        text-align: center;
        left: 20px;
        top: 50px;
    }
    .info-wrapper > .cut > label{
        font-size: 18px;
    }
    .info-wrapper > .cut > input{
        width: 60px;
    }
    .info-wrapper > div {
        display: block;
    }
    .info-wrapper > div > .img-container {
        border-radius: 50%;
        -webkit-box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
        -moz-box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
        box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
    }
    .info-wrapper > label {
        font-weight: bold;
    }
    .info-wrapper > div > div {
        width: 100px;
        height: 40px;
        margin: 5px;
        display: inline-block;
    }
    .info-wrapper > div > div > img {
        width: 100px;
        padding: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdminsProfiles/AdminProfile.vue